import React from 'react';
import PropTypes from 'prop-types';

import OEToolbox from '../../../../lib/tools/oe-toolbox-core';
import {OEIconButton} from '../../controls/oe-button';
import {OEObjectModelValueIcons, OEObjectModelValueEditHelper, OEObjectModelValueEditDecls, OEObjectModelValueCellStyleOptions} from '../oe-object-model-value-edit-model';

export default class OEObjectModelValueCell extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.state = {
            className:          OEObjectModelValueEditHelper.cellStyleOptionsToClassName(this.props.styleOptions, this.props.className),
            isCollapsible:      OEObjectModelValueEditHelper.includesCellStyleOption(this.props.styleOptions, OEObjectModelValueCellStyleOptions.collapsible),
            collapsed:          !!this.props.collapsed
        };

        this.onCollapseButtonPressed = this.onCollapseButtonPressed.bind(this);
    }

    setCollapsed(collapsed) {
        this.setState({collapsed: !!collapsed});
    }

    componentWillReceiveProps(nextProps)    {
        if(!OEToolbox.shallowEqual(nextProps.styleOptions, this.props.styleOptions) || nextProps.className !== this.props.className)    {
            this.setState({
                className:      OEObjectModelValueEditHelper.cellStyleOptionsToClassName(nextProps.styleOptions, nextProps.className),
                isCollapsible:  OEObjectModelValueEditHelper.includesCellStyleOption(this.props.styleOptions, OEObjectModelValueCellStyleOptions.collapsible)
            });
        }

        if(nextProps.collapsed !== this.props.collapsed && typeof(nextProps.collapsed) === 'boolean')    {
            this.setCollapsed(nextProps.collapsed);
        }
    }

    render()    {

        let collapsed = this.state.isCollapsible && this.state.collapsed;

        return  (
            <div className={'object-value-cell ' + this.props.type + (this.state.className ? ' ' + this.state.className : '')}>

                <div className="content">

                    {!(this.props.label || (this.props.type && this.props.showType)) ? null :
                        <div className="bar">

                            {this.props.label ? <span className="label">{this.props.label}</span> : null}

                            {this.props.showType && this.props.type ? <span className="type">{this.props.type}</span> : null}

                        </div>
                    }

                    {!this.state.isCollapsible ? null :
                        <div className="control-bar">
                            <OEIconButton
                                className="collapsible-toggle"
                                icon={this.state.collapsed ? OEObjectModelValueIcons.collapsed : OEObjectModelValueIcons.notCollapsed}
                                onPressed={this.onCollapseButtonPressed}
                            />
                        </div>
                    }

                    <div
                        className={'std-label-border-color edit-element ' + (this.props.type ? this.props.type : 'undefined') + ' edit-type-' + (this.props.editType ? this.props.editType : 'undefined') + (collapsed ? ' collapsed' : '')}
                    >
                        {this.props.children}
                    </div>

                </div>

            </div>
        );
    }

    onCollapseButtonPressed()   {
        this.setCollapsed(!this.state.collapsed);
    }
};

OEObjectModelValueCell.defaultProps = {
    className:                  '',
    name:                       'unnamed',
    showType:                   true
};

OEObjectModelValueCell.propTypes = {
    className:                  PropTypes.string,
    name:                       PropTypes.string,
    type:                       PropTypes.string,
    editType:                   PropTypes.string,
    label:                      PropTypes.string,
    showType:                   PropTypes.bool,
    styleOptions:               OEObjectModelValueEditDecls.styleOptions,
    collapsed:                  PropTypes.bool,
    onChange:                   PropTypes.func
};